import * as angular from 'angular';
import { downgradeComponent } from '@angular/upgrade/static';
import { DatasetHeaderDropdownComponent } from '@mode/dataset/feature-header';

export const DowngradedDatasetFeatureHeaderModule = angular
  .module('downgraded-dataset-feature-header', [])
  .directive('modeDatasetHeaderDropdown', downgradeComponent({ component: DatasetHeaderDropdownComponent })).name;
